import apiClient from "./api";

/**
 * Change Impact API Service (Refactored)
 * On-demand analysis using SAP WhatsNew
 */
export const changeImpactApi = {
  /**
   * Analyze change impact for a customer (on-demand)
   * @param {string} customerId - Customer UUID
   * @param {string} releaseVersion - Optional release version (defaults to latest)
   * @returns {Promise} Impact analysis report
   */
  analyzeChangeImpact: (customerId, releaseVersion = null) => {
    const body = releaseVersion ? { releaseVersion } : {};
    return apiClient.post(`/api/change-impacts/analyze/${customerId}`, body);
  },

  /**
   * Get available SAP release versions (from SAP API)
   * @returns {Promise} Array of release versions
   */
  getAvailableReleases: () => {
    return apiClient.get('/api/change-impacts/releases');
  },

  /**
   * Get stored release versions from database
   * @returns {Promise} Array of release versions
   */
  getStoredReleases: () => {
    return apiClient.get('/api/change-impacts/stored-releases');
  },
};

// Default export
export default changeImpactApi;
